import { Link } from "react-router-dom";

interface ErrorFallbackLayoutProps {
  children: React.ReactNode;
}

export function ErrorFallbackLayout({ children }: ErrorFallbackLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-brand-surface text-brand-ink">
      <header className="border-b border-brand-outline-variant/50 bg-brand-surface-lowest">
        <div className="portal-container flex h-14 items-center">
          <Link
            to="/"
            className="font-display text-lg font-bold text-brand-primary hover:opacity-90"
          >
            Eusebio News
          </Link>
        </div>
      </header>
      <main className="portal-container flex flex-1 items-center justify-center py-12">{children}</main>
    </div>
  );
}
